module.exports = __webpack_public_path__ + "img/small_og.755ec8a9.svg";